import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ApiConfig} from '../../core/config/api.config';
import {ADMISSIONS_SERVICE} from '../../core/config/api.constants';
import {endpoint} from '../path.constants';
import {ApiResponse} from '../api-response.model';
import {AdmissionEnumData} from '../enum/enum.model';


@Injectable({providedIn: 'root'})
export class AdmissionsService {
    private readonly baseUrl = ApiConfig.getBaseUrl(ADMISSIONS_SERVICE);

    private _instituteToken: string = "";
    constructor(private http: HttpClient) {
    }

    set setInstituteToken(value: string) {
        this._instituteToken = value;
    }

    getAdmissionEnum() {
        const headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        return this.http.get<ApiResponse<AdmissionEnumData>>(
            this.baseUrl + endpoint.admissions.enum, {headers}
        );
    }

    getAdmissionApplicationFee(courseId: number) {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);

        let url = this.baseUrl + endpoint.admissions.application_fee;
        return this.http.get<ApiResponse<any>>(
            url + "?course_id=" + courseId, {headers}
        );
    }

    submitAdmission(payload: any) {
        let headers = new HttpHeaders(ApiConfig.secretKeyHeader());
        headers = headers.append('Institute-Token', this._instituteToken);

        const url = this.baseUrl + endpoint.admissions.submit
        return this.http.post<ApiResponse<any>>(
            url, payload, {headers}
        );
    }
}
